import { Injectable } from '@angular/core';
import { BehaviorSubject, distinctUntilChanged, fromEvent, interval, map, merge, Observable, of } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class NetworkStatusService {
	private online$ = new BehaviorSubject<boolean>(navigator.onLine);

	readonly isOnline$ = merge(
		of(navigator.onLine),
		fromEvent(window, 'online').pipe(map(() => true)),
		fromEvent(window, 'offline').pipe(map(() => false)),
		fromEvent(window, 'focus').pipe(map(() => navigator.onLine)),
		fromEvent(document, 'visibilitychange').pipe(map(() => navigator.onLine)),
		interval(5000).pipe(map(() => navigator.onLine))
	).pipe(distinctUntilChanged());

	constructor() {
		this.isOnline$.subscribe(status => this.online$.next(status));
	}

	getStatus(): boolean {
		return this.online$.value;
	}
}
